export default __webpack_public_path__ + "static/media/art-4-carrots-sm.a1b24f3f.jpg";